import React, { useEffect } from "react";
import { Layout } from "antd";
import HouseVisitForm from "./form/HouseVisitForm";
import ModalHeader from "./form/ModalHeader";
import HouseVisitWrapper from "./index.style";
import { useDispatch } from "react-redux";
import { reset } from "./houseVisitSlice";

const HouseVisit = (props) => {
  const { hide, mode, loadPage } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    return function cleanup() {
      dispatch(reset());
    };
  }, []);

  return (
    <Layout>
      <HouseVisitWrapper>
        <ModalHeader hide={hide} mode={mode} />
        <HouseVisitForm mode={mode} hide={hide} load={loadPage} />
      </HouseVisitWrapper>
    </Layout>
  );
};

export default HouseVisit;
